import {

    getPlanList,
    getAuditList,
    getAuditData,
    getClzdApply,
    getZxpsApply
} from "@/api/xgpg";
import { getXmxxList, getDict } from "@/api/common";

const state = {
    xmList: [],
    planList: [],
    auditList: {
        total: 0,
        list: []
    },
    auditList2: {
        total: 0,
        list: []
    },
    auditData: {
        isReview: 0,
        fgsReview: {},
        zxbReview: {}
    },
    auditData2: {
        zxs: {},
        fgs: {},
        zxglb: {}
    },
    applyData2: {
        fgsReview: {},
        zxbReview: {}
    },
    pglxList: [],
};
const mutations = {
    fetchPglxList(state, res) {
        if (res.code == 0) {
            state.pglxList = res.data;
        }
    },
    fetchXmxxList(state, res) {
        if (res.code == 0) {
            state.xmList = res.data;
        }
    },
    fetchPlanList(state, res) {
        if (res.code == 0) {
            state.planList = res.data;
        }
    },
    fetchAuditList(state, res) {
        if (res.code == 0) {
            state.auditList = { total: res.count, list: res.data };
        }
    },
    fetchAuditList2(state, res) {
        if (res.code == 0) {
            state.auditList2 = { total: res.count, list: res.data };
        }
    },
    fetchAuditData(state, res) {
        if (res.code == 0) {
            if (!res.data.fgsReview) {
                res.data.fgsReview = {}
            }
            if (!res.data.zxbReview) {
                res.data.zxbReview = {}
            }
            state.auditData = {
                ...{
                    fgsReview: {},
                    zxbReview: {}
                }, ...res.data,
            };
            if (res.data.jdName === '效果评估报告编写') {
                state.auditData.v3 = res.data.v3 == 1;
                state.auditData.v5 = res.data.v5 == 1;
            }
        } else {
            state.auditData = {
                fgsReview: {},
                zxbReview: {}
            };
        }
    },
    fetchApplyData2(state, res) {
        if (res.code == 0) {
            if (!res.data.fgsReview) {
                res.data.fgsReview = {}
            }
            if (!res.data.zxbReview) {
                res.data.zxbReview = {}
            }
            state.applyData2 = {
                ...{
                    fgsReview: {},
                    zxbReview: {}
                }, ...res.data,
            };
            if (res.data.jdName === '效果评估报告编写') {
                state.applyData2.v3 = res.data.v3 == 1;
                state.applyData2.v5 = res.data.v5 == 1;
            }

        } else {
            state.applyData2 = {
                fgsReview: {},
                zxbReview: {}
            };
        }
    },

};
const actions = {
    fetchPglxListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getDict('assess_type')
                .then((res) => {
                    context.commit("fetchPglxList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchXmxxListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getXmxxList(payload)
                .then((res) => {
                    context.commit("fetchXmxxList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchPlanListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getPlanList(payload)
                .then((res) => {
                    context.commit("fetchPlanList", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchAuditListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getAuditList(payload)
                .then((res) => {
                    res.page = payload.page;
                    if (payload.status == 0) {
                        context.commit("fetchAuditList", res);
                    } else {

                        context.commit("fetchAuditList2", res);
                    }

                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchAuditDataAction(context, payload) {
        return new Promise((resolve, reject) => {
            getAuditData(payload)
                .then((res) => {
                    context.commit("fetchAuditData", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },




    fetchApplyData2Action(context, payload) {
        return new Promise((resolve, reject) => {
            getZxpsApply(payload)
                .then((res) => {
                    context.commit("fetchApplyData2", res);
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
